import React from "react";
import { useNavigate } from "react-router-dom";
import "./DynamicButton.css";

/**
 * Reusable SaaS-ready dynamic button
 */
const DynamicButton = ({
  text = "",
  icon = "fa-plus",
  size = "md",
  variant = "primary",
  link = "",
  onClick,
  disabled = false,
  title = "",
  ariaLabel = "",
  className = "",

  // customization props
  bgColor,
  textColor,
  hoverBgColor,
  hoverTextColor,
  outlineColor,
}) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (disabled) return;

    if (link) navigate(link);
    if (onClick) onClick(e);
  };

  const customStyle = {
    ...(bgColor ? { "--custom-bg": bgColor } : {}),
    ...(textColor ? { "--custom-text": textColor } : {}),
    ...(hoverBgColor ? { "--custom-hover-bg": hoverBgColor } : {}),
    ...(hoverTextColor ? { "--custom-hover-text": hoverTextColor } : {}),
    ...(outlineColor ? { "--custom-border": outlineColor } : {}),
  };

  return (
    <button
      type="button"
      className={`dynamic-btn ${size} ${variant} ${className} ${
        disabled ? "disabled" : ""
      }`}
      onClick={handleClick}
      disabled={disabled}
      title={title || text}
      aria-label={ariaLabel || title || text || icon}
      style={customStyle}
    >
      {icon && (
        <i
          className={`fas ${icon}`}
          style={{ marginRight: text ? 8 : 0 }}
          aria-hidden="true"
        />
      )}

      {text && <span>{text}</span>}
    </button>
  );
};

export default DynamicButton;
